import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type OnClickModalProps = {
  isClicked: boolean;
  message: string;
  type: 'error' | 'warning' | 'info' | 'success';
  handleClose: () => void;
};

const OnClickModal = ({ isClicked, message, type, handleClose }: OnClickModalProps) => {
  const [hidden, setHidden] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setHidden(!isClicked);
  }, [isClicked]);

  const close = () => handleClose();

  return (
    <Dialog open={!hidden} onClose={close}>
      <DialogContent>
        <DialogContentText color={type}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} autoFocus>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OnClickModal;
